"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FieldRadio = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dedupe = _interopRequireDefault(require("classnames/dedupe"));

var _uuid = require("uuid");

var _CheckHolder = require("../icons/CheckHolder");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var setMinWidth = function setMinWidth(element) {
  if (element) {
    element.style.fontWeight = 'bold';
    element.style.minWidth = "".concat(element.getBoundingClientRect().width, "px");
    element.style.fontWeight = '';
  }
};

var FieldRadio =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(FieldRadio, _React$PureComponent);

  function FieldRadio(props) {
    var _this;

    _classCallCheck(this, FieldRadio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FieldRadio).call(this, props));
    var _this$props = _this.props,
        value = _this$props.value,
        children = _this$props.children;
    _this.state = {
      value: _typeof(children) === 'object' ? value : children
    };
    _this.radioRef = _react.default.createRef(); // uuid created for case when value or children the same for different element

    _this.uuid = (0, _uuid.v4)();
    return _this;
  }

  _createClass(FieldRadio, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.radioRef && this.radioRef.current) {
        setMinWidth(this.radioRef.current);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var isFocused = this.props.isFocused;

      if (isFocused) {
        this.radioRef.current.focus();
      }
    } // normally we should never disable complexity errors
    // but since this Cstar and it would be very hard to refactor this out
    // I am not going to work on that just to be able use spread props
    // eslint-disable-next-line complexity

  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props2 = this.props,
          id = _this$props2.id,
          children = _this$props2.children,
          value = _this$props2.value,
          cssClass = _this$props2.cssClass,
          role = _this$props2.role,
          styleType = _this$props2.styleType,
          checkmarkClass = _this$props2.checkmarkClass,
          tabIndex = _this$props2.tabIndex,
          isChecked = _this$props2.isChecked,
          isFocused = _this$props2.isFocused,
          handleClick = _this$props2.handleClick,
          handleKeydown = _this$props2.handleKeydown,
          handleFocus = _this$props2.handleFocus,
          handleBlur = _this$props2.handleBlur,
          ariaControls = _this$props2.ariaControls;
      var className = (0, _dedupe.default)((_classNames = {}, _defineProperty(_classNames, "".concat(cssClass), cssClass), _defineProperty(_classNames, "".concat(cssClass, "--selected"), cssClass && isChecked), _defineProperty(_classNames, 'radio-focused', isFocused), _classNames));
      var showCheckmark = styleType === 'radiobutton' || styleType === 'checkedpicker';
      var fieldRadioTopDivProps = {
        id: id,
        className: className,
        role: role,
        tabIndex: tabIndex,
        ref: this.radioRef,
        'aria-labelledby': "".concat(id, "-label"),
        onClick: function onClick(e) {
          return handleClick(e, value);
        },
        onKeyDown: function onKeyDown(e) {
          return handleKeydown(e, value);
        },
        onFocus: function onFocus(e) {
          return handleFocus(e, value);
        },
        onBlur: function onBlur(e) {
          return handleBlur(e, value);
        }
      };

      if (role === 'radio') {
        fieldRadioTopDivProps['aria-checked'] = isChecked;
      }

      if (role === 'tab') {
        fieldRadioTopDivProps['aria-selected'] = isChecked;
        fieldRadioTopDivProps['aria-controls'] = ariaControls;
      }

      return (// this disables the warning when role is a variable
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        _react.default.createElement("div", fieldRadioTopDivProps, showCheckmark && _react.default.createElement(_CheckHolder.CheckHolder, {
          cssClass: checkmarkClass,
          showUnchecked: styleType === 'radiobutton',
          isChecked: isChecked
        }), _react.default.createElement("div", {
          id: "".concat(id, "-label")
        }, children || value, this.state.value !== (_typeof(children) === 'object' ? value : children) && this.setState({
          value: _typeof(children) === 'object' ? value : children
        })))
      );
    }
  }]);

  return FieldRadio;
}(_react.default.PureComponent);

exports.FieldRadio = FieldRadio;
FieldRadio.defaultProps = {
  id: null,
  cssClass: 'radio-button',
  checkmarkClass: 'radio-icon',
  role: 'radio',
  children: null,
  tabIndex: -1,
  isChecked: false,
  isFocused: false,
  handleFocus: null,
  handleBlur: null,
  ariaControls: 'tabpanel'
};
FieldRadio.propTypes = {
  id: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.bool]).isRequired,
  children: _propTypes.default.node,
  tabIndex: _propTypes.default.number,
  isChecked: _propTypes.default.bool,
  isFocused: _propTypes.default.bool,
  styleType: _propTypes.default.oneOf(['radiobutton', 'picker', 'checkedpicker']).isRequired,
  cssClass: _propTypes.default.string,
  checkmarkClass: _propTypes.default.string,
  role: _propTypes.default.string,
  handleClick: _propTypes.default.func.isRequired,
  handleKeydown: _propTypes.default.func.isRequired,
  handleFocus: _propTypes.default.func,
  handleBlur: _propTypes.default.func,
  ariaControls: _propTypes.default.string
};